export const ADMIN = 'ADMIN';
export const FULLADMIN = 'FULLADMIN';
export const LISTADMIN = 'LISTADMIN';
export const READONLYUSER = 'READONLYUSER';
